"use client";

import { type ReactNode, useEffect, useRef, useState } from "react";

type FloatingServiceHeroProps = {
    children: ReactNode;
    className: string;
};

/** Positions the banner edge through the visual centre of the hero card. */
export default function FloatingServiceHero({ children , className }: FloatingServiceHeroProps) {
    const heroRef = useRef<HTMLDivElement>(null);
    const [heroOffset, setHeroOffset] = useState<number>();

    useEffect(() => {
        const hero = heroRef.current;
        if (!hero) return;

        const updateHeroOffset = () => {
            setHeroOffset(hero.getBoundingClientRect().height / 2);
        };

        updateHeroOffset();
        const observer = new ResizeObserver(updateHeroOffset);
        observer.observe(hero);

        return () => observer.disconnect();
    }, []);

    return (
        <div
            className={`bg-[#f6efe4] relative z-10 ${className}`}
            style={heroOffset ? { marginTop: -heroOffset } : undefined}
        >
            <div className="absolute w-full flex justify-center z-10 -mt-32 mb-12 md:-mt-40 md:mb-16" ref={heroRef}>{children}</div>
        </div>
    );
}
